import { Component, OnInit, Input } from '@angular/core';
import { Entry, Asset } from 'contentful';
import { SecureLink, Footer } from '../../_models/footer.model';
import { ImageLink } from '../../_models/imageLink.model';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Header } from '../../_models/header.model';
import { Theme } from '../../_models/theme.model';

@Component({
  selector: 'app-header',
  standalone: false,
  templateUrl: './header.component.html',
  styleUrl: './header.component.css'
})
export class HeaderComponent implements OnInit {
  @Input() headerContent: Entry<Header> | undefined;
  @Input() themeContent: Entry<Theme> | undefined;

  imageURL: string | undefined = "";

  constructor(
    private sanitizer: DomSanitizer
  ) { }


  ngOnInit(): void {
    this.loadImgURL();
  }

  loadImgURL() {
    this.imageURL = this.headerContent?.fields.backGroundImageUrl?.['fields']?.['file']?.['url'];
  }

  getSafeImageUrl(imageURL: string): SafeUrl {
    const url = `https:${imageURL}`;
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }



}
